import React, { useState, useEffect } from "react";
import api from "../utils/api";
import { useAuth } from "../contexts/AuthContext";

const MyAccount = () => {
  const [profile, setProfile] = useState(null);
  const { user } = useAuth();

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await api.get("/user/profile");
        setProfile(res.data.data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchProfile();
  }, []);

  if (!profile) return <div>Loading...</div>;

  return (
    <div className="card main-content max-w-xl">
      <div className="flex gap-2 items-center mb-4">
        <img
          src={profile.profilePicture ? profile.profilePicture : "/default.png"}
          alt="Profile"
          className="profile-pic"
        />
        <h2 className="mb-0">{profile.name}</h2>
      </div>

      <div className="card flex flex-col">
        <span>
          <strong>User ID:</strong> {profile.userId}
        </span>
        <span>
          <strong>Email:</strong> {profile.email}
        </span>
        <span>
          <strong>Phone:</strong> {profile.phone}
        </span>
        <span>
          <strong>Date of Birth:</strong>{" "}
          {new Date(profile.dob).toLocaleDateString()}
        </span>
        <span>
          <strong>PAN Number:</strong> {profile.panNumber}
        </span>
      </div>

      <div className="card">
        <h3 className="mt-4">Bank Details</h3>
        <div className="flex flex-col">
          <span>
            <strong>Bank Name:</strong> {profile.bankDetails.bankName}
          </span>
          <span>
            <strong>Account Number:</strong> {profile.bankDetails.accountNumber}
          </span>
          <span>
            <strong>IFSC Code:</strong> {profile.bankDetails.ifscCode}
          </span>
        </div>
      </div>

      {profile.hasReferrer && (
        <div className="card">
          <h3 className="mt-4">Referrer Details</h3>
          <div className="flex flex-col">
            <span>
              <strong>Name:</strong> {profile.referrerName}
            </span>
            <span>
              <strong>Contact:</strong> {profile.referrerContact}
            </span>
          </div>
        </div>
      )}

      {profile.hasNominee && (
        <div className="card">
          <h3 className="mt-4">Nominee Details</h3>
          <div className="flex flex-col">
            <span>
              <strong>Name:</strong> {profile.nomineeName}
            </span>
            <span>
              <strong>Contact:</strong> {profile.nomineeContact}
            </span>
            <span>
              <strong>Relation:</strong> {profile.nomineeRelation}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default MyAccount;
